import { render, staticRenderFns } from "./formfactory.vue?vue&type=template&id=131ff422&scoped=true&"
import script from "./formfactory.vue?vue&type=script&lang=js&"
export * from "./formfactory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131ff422",
  null
  
)

export default component.exports